import React from "react";
import { Link } from "react-router-dom";
import PackageCard from "../shared/PackageCard";
import { SkeletonCard } from "../shared/Skeleton";
import EmptyState from "../shared/EmptyState";
import { t } from "../../lib/i18n";

export default function PackagesRail({ packages, coversByPkgId, loading }) {
  return (
    <section
      data-testid="home-packages-section"
      className="bg-white/40 py-16 sm:py-20"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-6">
        <div className="mb-8 flex flex-col gap-3 sm:mb-12 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="font-display text-3xl text-[#1A1A1A] sm:text-4xl">
              {t("home.packages.title")}
            </h2>
            <p className="mt-3 max-w-xl text-base text-[#1A1A1A]/60">
              {t("home.packages.subtitle")}
            </p>
          </div>
          <Link
            to="/packages"
            data-testid="home-packages-view-all"
            className="text-xs uppercase tracking-[0.28em] text-[#1A1A1A]/70 transition hover:text-[#C8A24B]"
          >
            {t("home.viewAll.packages")} →
          </Link>
        </div>

        {loading ? (
          <ul className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {[0, 1, 2].map((i) => (
              <li key={i}>
                <SkeletonCard />
              </li>
            ))}
          </ul>
        ) : !packages.length ? (
          <EmptyState
            title="No packages yet"
            subtitle="Our catalog will be live shortly."
            testid="home-packages-empty"
          />
        ) : (
          <ul
            data-testid="home-packages-rail"
            className="-mx-5 flex snap-x snap-mandatory gap-5 overflow-x-auto px-5 pb-3 md:mx-0 md:grid md:grid-cols-3 md:px-0 md:pb-0"
          >
            {packages.map((p) => (
              <li
                key={p.id}
                className="w-[82%] shrink-0 snap-start md:w-auto"
              >
                <PackageCard pkg={p} coverImage={coversByPkgId[p.id]} />
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
